// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkboxWithText_checkbox__J0ba8"};